module.exports = __webpack_public_path__ + "img/qr-login.6842ba3.png";